import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EntitlementsContext = createContext(null);

// Until the plan is known, assume everything is allowed so the UI never flickers features away
// from a paying customer on a slow network. The server is the real gate either way.
const OPTIMISTIC = { features: null, limits: {}, usage: {}, plan: null, loading: true };
export const EntitlementsProvider = ({ children }) => {
  const { user } = useAuth();
  const [state, setState] = useState(OPTIMISTIC);

  const refresh = useCallback(async () => {
    if (!user) {
      setState(OPTIMISTIC);
      return;
    }
    try {
      const { data } = await api.get("/entitlements");
      setState({ ...data, loading: false });
    } catch {
      setState({ ...OPTIMISTIC, loading: false });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const can = useCallback(
    (feature) => {
      if (!feature) return true;
      if (!state.features) return true;
      return !!state.features[feature];
    },
    [state.features],
  );

  return (
    <EntitlementsContext.Provider value={{ ...state, can, refresh }}>
      {children}
    </EntitlementsContext.Provider>
  );
};

export const useEntitlements = () => useContext(EntitlementsContext) || { can: () => true, limits: {}, usage: {}, loading: false, refresh: async () => {} };
